// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IMyHomeStatusInfoSchema {
  /** Код **/
  code: ECode;
  /** Текст **/
  text: string;
}
export enum ECode {
  /** Инвестирую в этот объект **/
  'Investment' = 'investment',
  /** Хочу продать **/
  'NeedSale' = 'needSale',
  /** Не выбрано **/
  'NotSelected' = 'notSelected',
  /** Просто интересуюсь **/
  'Other' = 'other',
  /** Сдаю или хочу сдать **/
  'RentOrNeedRent' = 'rentOrNeedRent',
  /** Попросили оценить **/
  'SomebodyWantKnowPrice' = 'somebodyWantKnowPrice',
  /** Решаю, сдавать или продавать **/
  'ThinkRentOrSale' = 'thinkRentOrSale',
  /** Прикидываю, сколько получу от продажи **/
  'WantKnowSalePrice' = 'wantKnowSalePrice',
  /** Хочу купить **/
  'WantToBuy' = 'wantToBuy',
}
